import { render, staticRenderFns } from "./ApproveReturn.vue?vue&type=template&id=a6ae20f4&scoped=true&"
import script from "./ApproveReturn.ts?vue&type=script&lang=ts&"
export * from "./ApproveReturn.ts?vue&type=script&lang=ts&"
import style0 from "./ApproveReturn.vue?vue&type=style&index=0&id=a6ae20f4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6ae20f4",
  null
  
)

export default component.exports